import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { TreeItemFlatNode, TreeItemNode } from '@app/models/storage.interface';
import { StorageAddComponent } from '@app/modules/storages/storage-add/storage-add.component';
import { BreakpointService } from '@app/services/breakpoint/breakpoint.service';
import { StoragesService } from '@app/services/storages/storage.service';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

@Component({
  selector: 'app-product-storage-treeview',
  templateUrl: './product-storage-treeview.component.html',
  styleUrls: ['./product-storage-treeview.component.scss']
})
export class ProductStorageTreeviewComponent implements OnInit {
  public TREE_DATA:any[] = [];
  public searchQuery: string = '';
  public title: string = '';
  public all_items_active: boolean = true;
  public isFilter: boolean = true;
  public showAddButton: boolean = true;
  public singleSelect: boolean = false;
  treeData: any[];
  isLoading = true;
  treeControl: FlatTreeControl<TreeItemFlatNode>;
  dataSource: MatTreeFlatDataSource<TreeItemNode, TreeItemFlatNode>;
  flatNodeMap = new Map<TreeItemFlatNode, TreeItemNode>();
  nestedNodeMap = new Map<TreeItemNode, TreeItemFlatNode>();
  treeFlattener: MatTreeFlattener<TreeItemNode, TreeItemFlatNode>;
  checklistSelection = new SelectionModel<TreeItemFlatNode>(true /* multiple */);
  selectedItems: TreeItemFlatNode[] = [];
  


  constructor(private storagesService: StoragesService,
    private _translation: TranslateService,
    private store$: Store, 
    private _breakpoints:BreakpointService,  
    private _matDialog: MatDialog, 
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ProductStorageTreeviewComponent>,) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel,
      this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<TreeItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    this.isFilter = (data.isFilter!=null && data.isFilter!=undefined && data.isFilter==true) ? true : false;
    this.showAddButton = (data.showAddButton!=null && data.showAddButton!=undefined && data.showAddButton==false) ? false : true;
    this.title = (data.title!=null && data.title!=undefined && data.title!='') ? data.title : '';
    this.singleSelect = (data.singleSelect!=null && data.singleSelect!=undefined && data.singleSelect==true) ? true : false;

    this.storagesService.getAllItems('name', 'asc','','',0).pipe(
      map(data => data.storages.map(item => {
        this.TREE_DATA.push({
          storageStructureID: item.storageStructureID,
          parentID: item.parentID,
          item: item.name,
          path: item.path,
          level: item.level,
          expandable: item.hasChildren,
          code: item.code,
          parentcode: item.parentcode,
          isSelected: true
        });
      }))
    ).subscribe(result => {
      const data = this.buildFileTree(this.TREE_DATA, '0');
      this.treeData = this.TREE_DATA;
      this.dataSource.data = data;
      this.isLoading = false;
    }
    );

    // if(this.data!=undefined && this.data!=null){
    //   for (const item of this.data) {
    //     let node = this.findItemByCode(undefined,item.code);
    //     if(node){
    //       node.isSelected = true;
    //       this.todoItemSelectionToggle(node);
    //     }
    //   }
    // }


  }

  ngOnInit(): void {
   // this.checklistSelection.clear();
  }

  getLevel = (node: TreeItemFlatNode) => node.level;
  isExpandable = (node: TreeItemFlatNode) => node.expandable;
  isSelected = (node: TreeItemFlatNode) => node.isSelected;
  getChildren = (node: TreeItemNode): TreeItemNode[] => node.children;
  hasChild = (_: number, _nodeData: TreeItemFlatNode) => _nodeData.expandable;

  transformer = (node: TreeItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.item === node.item
      ? existingNode
      : new TreeItemFlatNode();
    flatNode.item = node.item;
    flatNode.level = level;
    flatNode.code = node.code;
    flatNode.path = node.path;
    flatNode.parentcode = node.parentcode;
    flatNode.parentID = node.parentID;
    flatNode.isSelected = node.isSelected;
    flatNode.storageStructureID = node.storageStructureID;
    flatNode.expandable = node.children && node.children.length > 0;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  }

  buildFileTree(obj: any[], level: string): TreeItemFlatNode[] {

    return obj.filter(o =>
      (<string>o.code).startsWith(level + '.')
      && (o.code.match(/\./g) || []).length === (level.match(/\./g) || []).length + 1
    )
      .map(o => {
        const node = new TreeItemFlatNode();
        node.item = o.item;
        node.code = o.code;
        node.path = o.path;
        
        const foundItem = this.data.storages.find(d => d.storageStructureID === o.storageStructureID);
        if(foundItem){
          node.isSelected = true;
          this.selectedItems.push(node);
        }
        else{
          node.isSelected = false;
          this.selectedItems = this.selectedItems.filter(n => n.code !== o.code);
        }
        node.parentcode = o.parentcode;
        node.parentID = o.parentID;
        node.storageStructureID = o.storageStructureID;
        const children = obj.filter(so => (<string>so.code).startsWith(level + '.'));
        if (children && children.length > 0) {
          node.children = this.buildFileTree(children, o.code);
        }
        return node;
      });
  }

  filterChanged(filterText: any) {
    if(filterText.target!=null && filterText.target!=undefined && filterText.target.value!=null && filterText.target.value!=undefined){
      filterText = filterText.target.value;
    }
    else if(filterText==null || filterText==undefined || filterText=='') {
      filterText = '';
    }

    this.dataSource.data = this.buildFileTree(this.filter(filterText),'0');
    if(filterText)
    {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
  }

  public filter(filterText: string): TreeItemNode[]{
    let filteredTreeData;
    if (filterText) {
      filteredTreeData = this.treeData.filter(d => d.item.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1);
      Object.assign([], filteredTreeData).forEach(ftd => {
        let str = (<string>ftd.code);
        while (str.lastIndexOf('.') > -1) {
          const index = str.lastIndexOf('.');
          str = str.substring(0, index);
          if (filteredTreeData.findIndex(t => t.code === str) === -1) {
            const obj = this.treeData.find(d => d.code === str);
            if (obj) {
              filteredTreeData.push(obj);
            }
          }
        }
      });
    } else {
      filteredTreeData = this.treeData;
    }
    return filteredTreeData
  }

  allItems() {
    this.treeControl.dataNodes.forEach((element) => {
      element.active = false;
    });
    this.all_items_active = true;
    //this.dataList = this.dataSource.data;
    this.treeControl.collapseAll();
  }

  todoItemSelectionToggle(node: TreeItemFlatNode): void {
    this.all_items_active = false;
    this.treeControl.dataNodes.forEach((element) => {
      element.active = false;
    });
   
    this.treeControl.collapseAll();
    this.expanNodePath(this.treeControl.dataNodes, node);
   
    node.active = true;
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    var item = this.findItemByCode(undefined,node.code);
    if(item){
      item.isSelected = this.checklistSelection.isSelected(node);
    }
  }

  expanNodePath(data: any, storage: TreeItemFlatNode) {
    
    var nodeData = this.treeControl.dataNodes.filter(node => node.code == storage.code)[0];
    if(nodeData){
      nodeData.active = true;
      this.treeControl.expand(nodeData);
    }
    for (let node of data) {
      if(node.code == storage.parentcode){
        this.expanNodePath(data, node);
        this.treeControl.expand(node);
      }
    }
    return null;
  }

  buildNodePath(node: TreeItemFlatNode): string {
    let path = node.item;
    let parentNode = this.treeControl.dataNodes.find(n => n.code === node.parentcode);
    while (parentNode) {
      path = `${parentNode.item} -> ${path}`;
      parentNode = this.treeControl.dataNodes.find(n => n.code === parentNode.parentcode);
    }
    return path;
  }
  public findItemByCode(data:any = this.dataSource.data,targetCode: string): any {
    for (const item of data) {
        if (item.code === targetCode) {
            return item;
        }
        if (item.children && Array.isArray(item.children)) {
            const foundInChildren = this.findItemByCode(item.children, targetCode);
            if (foundInChildren) {
                return foundInChildren;
            }
        }
    }
    return null;
  }
  cancel(){
    this.dialogRef.close('cancel');
  }
  saveProductStorage(){

    this.selectedItems = this.selectedItems.filter((item, index, self) => 
      self.findIndex(i => i.code === item.code) === self.lastIndexOf(item)
    );

    // Attach the canonical path built from the loaded tree. Callers that need
    // to resolve a storage by name (e.g. Excel import) must not rely on the
    // cached `path` column, which different writers fill differently.
    this.selectedItems.forEach(item => item.fullPath = this.buildNodePath(item));

   // let selectedStorage = this.checklistSelection.selected;
    this.dialogRef.close(this.selectedItems);
  }

  onOpenStorage(node: TreeItemFlatNode){
    let currentStorageTitle = '';
    if(node==null || node==undefined){
      currentStorageTitle = this._translation.instant('all_storages');
    } else{
      currentStorageTitle = this.buildNodePath(node);
    }
    const dialog = this._matDialog.open(StorageAddComponent, {
      data: {
        type: 'Add',
        area: null,
        parentStorageStructureID:  node!=undefined ? node.storageStructureID : 0,
        path: node!=undefined ? node.item:'',
        currentAddTitle: currentStorageTitle.replace(this._translation.instant('all_storages') + ' -> ','')
      },
      width: this._breakpoints.isMobile() === true ? "70vw" : "30vw",
    });

    dialog.afterClosed().subscribe(res => {
      if(res!=null && res.name!=null){
        var obj = {
          children: [],
          item: res.name,
          parentID: res.parentID,
          path: res.path,
          code: res.code,
          parentcode: res.parentcode,
          isSelected: false,
          storageStructureID: res.storageStructureID,
        };
        const newItem = { ...obj};
        this.treeData.push(newItem);
        this.selectedItems = [];
        const data = this.buildFileTree(this.TREE_DATA, '0');
        this.treeData = this.TREE_DATA;
        this.dataSource.data = data;
        this.expanNodePath(this.treeControl.dataNodes, node);
      }
    });
  }

  onSelectionChange(node: TreeItemFlatNode): void {
    const item = this.findItemByCode(undefined, node.code);
    this.storagesService.updateStoragePath(item.storageStructureID).subscribe(res => {
      node.path = res.path;
      if (item) {
        // Single select mode: deselect all other items first
        if (this.singleSelect && node.isSelected) {
          // Deselect all currently selected items
          this.selectedItems.forEach(selectedNode => {
            selectedNode.isSelected = false;
            const selectedItem = this.findItemByCode(undefined, selectedNode.code);
            if (selectedItem) {
              selectedItem.isSelected = false;
            }
          });
          this.selectedItems = [];

          // Deselect all nodes in tree
          this.treeControl.dataNodes.forEach(n => {
            n.isSelected = false;
          });

          // Re-select the current node
          node.isSelected = true;
        }

        item.isSelected = node.isSelected;

        if (node.isSelected) {
          this.selectedItems.push(node);
        } else {
          this.selectedItems = this.selectedItems.filter(n => n.code !== node.code);
        }

        // Cascading selection - update all descendants (only for multi-select mode)
        if (!this.singleSelect) {
          const descendants = this.treeControl.getDescendants(node);
          descendants.forEach(descendant => {
            descendant.isSelected = node.isSelected;
            const descItem = this.findItemByCode(undefined, descendant.code);
            if (descItem) {
              descItem.isSelected = node.isSelected;
            }

            if (node.isSelected) {
              // Add to selectedItems if not already present
              if (!this.selectedItems.some(n => n.code === descendant.code)) {
                this.selectedItems.push(descendant);
              }
            } else {
              // Remove from selectedItems
              this.selectedItems = this.selectedItems.filter(n => n.code !== descendant.code);
            }
          });
        }
      }
    });
  }

  // updateSelectedItems(): void {
  //   this.selectedItems = this.treeControl.dataNodes.filter(node => node.isSelected);
  // }

}



